import styles from "./Clouds.module.css";

// Large blurred circles behind a section's content, ported from fb/web. Purely visual.
const PRESETS = {
  hero: ["teal topRight", "coral bottomLeft", "cream midLeft"],
  left: ["teal topLeft", "coral bottomRight"],
  right: ["teal topRight", "cream bottomLeft"],
};

const Clouds = ({ preset = "left" }: { preset?: keyof typeof PRESETS }) => (
  <div aria-hidden='true' className={styles.clouds}>
    {PRESETS[preset].map((names) => (
      <span key={names} className={[styles.cloud, ...names.split(" ").map((name) => styles[name])].join(" ")} />
    ))}
  </div>
);

export default Clouds;
